import React from 'react';
import './Chat.css';
import ChatHeader from './ChatHeader';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import GifIcon from '@material-ui/icons/Gif';
import EmojiEmoticonsIcon from '@material-ui/icons/EmojiEmotions';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import Message from './Message';
import { useSelector } from 'react-redux';
import { selectUser } from './features/userSlice';
import { selectChannelId, selectChannelName } from './features/appSlice';
import { useState, useRef } from 'react';
import { useEffect } from 'react';
import db from './firebase';
import firebase from 'firebase';


const Chat = () => {
    const dummy = useRef();
    const user = useSelector(selectUser)
    const channelId = useSelector(selectChannelId)
    const channelName = useSelector(selectChannelName)
    const [input, setInput] = useState('')
    const [messages, setMessages] = useState([])


    useEffect(() => {
        if (channelId) {
            db.collection('channels').doc(channelId).collection('messages').orderBy('timestamp', 'asc').onSnapshot(snapshot => {
                setMessages(snapshot.docs.map(doc => doc.data()))
            })
        }

        // if (channelId === dummy.current) {

        //     dummy.current.scrollIntoView({
        //         behavior: 'smooth',
        //         block: 'end'
        //     });
        // }


    }, [channelId])

    const sendMessage = (e) => {
        e.preventDefault()

        db.collection('channels').doc(channelId).collection('messages').add({
            message: input,
            user: user,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })

        setInput('');
        dummy.current.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });

    }

    return (
        <div className='chat' >
            <ChatHeader channelName={channelName} />
            {/* <h2>{messages.length}</h2> */}
            <div className="chat__messages">


                {messages.map(message => (

                    <Message key={message.timestamp * Math.random()} message={message.message} timestamp={message.timestamp} user={message.user} />
                ))}

                <div ref={dummy}>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                </div>
            </div>


            <div className="chat__input">
                <AddCircleIcon fontSize='large' />
                <form>
                    <input type="text" disabled={!channelId} value={input} onChange={(e) => setInput(e.target.value)}
                        placeholder={channelId ? `Message #${channelName}` : `Select a Channel or Create One`} />
                    {/* {!user ? 'Guest' : username} */}
                    <button className='chat__inputButton' onClick={sendMessage} disabled={input === ''} type='submit'>Send Message</button>
                </form>

                <div className="chat__inputIcons">
                    <PhotoLibraryIcon fontSize="large" />
                    <GifIcon fontSize='large' />
                    <EmojiEmoticonsIcon fontSize='large' />
                </div>
            </div>
        </div >
    )
}

export default Chat
